module.exports = __webpack_public_path__ + "img/book.629b6ab1.png";